/*
 * @Author: Teemo Ding
 * @Date: 2021-11-02 16:00:46
 * @LastEditTime: 2022-04-25 10:19:27
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/Components/ExclusiveCustom/index.tsx
 */
import React from 'react';
import ModalHoc from 'src/constrains/ModalHOC';
import SelectCustomisation from './SelectCustomisation';
import css from './css.module.less';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';

interface IProps {
  price?: string;
  className?: string;
  serviceDetails?;
  modalOp;
  onAdd?;
  onRemove?;
  productName?;
  sku?;
  defaultValue?;
  disabled?;
  data;
  customizationPrice?;
}

const ExclusiveCustom = ({
  price,
  className,
  serviceDetails,
  onAdd,
  data,
  onRemove,
  productName,
  defaultValue,
  disabled,
  sku,
  modalOp: { setShowModal, setModalTitle, setModalContent },
}: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const handleCancel = () => {
    setShowModal(false);
  };
  const handleAddCustomisation = () => {
    setModalTitle(getI18n('general.selectcustomisation'));
    setShowModal(true);
    setModalContent(
      <SelectCustomisation
        onCancel={handleCancel}
        serviceDetails={serviceDetails}
        onAdd={onAdd}
        productName={productName}
        sku={sku}
        defaultValue={defaultValue}
      />,
    );
  };

  return (
    <div className={`${className} ${css.customizationLine}`}>
      <div className={css.customization}>
        {(data || []).map((item, index) => (
          <div key={index}>
            {item.title && (
              <div className={css.customizationText}>{item.title}</div>
            )}
            {item.subTitle && (
              <div className={css.subCustomizationText}>{item.subTitle}</div>
            )}
          </div>
        ))}

        <div className={css.action}>
          {onAdd && (
            <div
              className={
                disabled ? css.disabledAddCustomization : css.addCustomization
              }
              onClick={!disabled ? handleAddCustomisation : undefined}>
              {(data || []).length
                ? getI18n('general.editcustomisation')
                : getI18n('general.addcustomisation')}
            </div>
          )}
          {onRemove && (data || []).length ? (
            <div
              className={
                disabled
                  ? css.disabledRemoveCustomization
                  : css.removeCustomization
              }
              onClick={!disabled && onRemove}>
              {getI18n('general.remove')}
            </div>
          ) : null}
        </div>
      </div>
      <div className={css.customizationPrice}>{price}</div>
    </div>
  );
};

export default ModalHoc(ExclusiveCustom);
